import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { MethodBadge } from '../components/method-badge';
import { reference } from '../generated/reference';

/** `/docs/api`: every tag with its operations. */
export function ReferenceIndexPage() {
  const { t } = useTranslation('docs');
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-10">
      <header className="flex flex-col gap-2">
        <h1 className="text-3xl font-semibold tracking-tight">{t('reference.title')}</h1>
        <p className="text-muted-foreground text-lg">{t('reference.description')}</p>
      </header>
      {reference.tags.map((tag) => (
        <section key={tag.key} aria-labelledby={`tag-${tag.key}`} className="flex flex-col gap-3">
          <div>
            <h2 id={`tag-${tag.key}`} className="text-xl font-semibold tracking-tight">
              {tag.title}
            </h2>
            {tag.description ? (
              <p className="text-muted-foreground mt-1 text-sm">{tag.description}</p>
            ) : null}
          </div>
          <ul className="divide-y rounded-lg border">
            {tag.operations.map((id) => {
              const operation = reference.operations[id];
              if (!operation) return null;
              return (
                <li key={id}>
                  <Link
                    to="/docs/api/$tag/$operation"
                    params={{ tag: tag.key, operation: operation.slug }}
                    className="hover:bg-accent flex flex-col gap-1 px-4 py-3 transition-colors sm:flex-row sm:items-center sm:gap-3"
                  >
                    <span className="flex min-w-0 items-center gap-3">
                      <MethodBadge method={operation.method} />
                      <span className="truncate font-medium">{operation.summary}</span>
                    </span>
                    <code className="text-muted-foreground truncate font-mono text-xs sm:ml-auto">
                      {operation.path}
                    </code>
                  </Link>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </div>
  );
}
